type Grant={id:string;deliverableIds:string[]};
const grants=new Map<string,Grant>();
const filmGrants=new Map<string,string>();
export function setProductionGrant(projectId:string,grant:Grant|null) {
  if(grant)grants.set(projectId,{id:grant.id,deliverableIds:[...grant.deliverableIds]});else grants.delete(projectId);
}
export function setFilmGrant(projectId:string,grantId:string|null) {
  if(grantId)filmGrants.set(projectId,grantId);else filmGrants.delete(projectId);
}
export function productionGrantFor(path:string,body:BodyInit|null|undefined):Grant|null {
  const match=/^\/api\/projects\/([^/?]+)\/(generations|agents\/run|screenplay\/interpret)$/.exec(path);
  if(!match||typeof body!=='string')return null;
  const projectId=decodeURIComponent(match[1]);
  let parsed:Record<string,unknown>;
  try{parsed=JSON.parse(body||'{}') as Record<string,unknown>;}catch{return null;}
  const grant=grants.get(projectId);
  if(grant&&match[2]==='generations'){
    const settings=(parsed.settings&&typeof parsed.settings==='object'?parsed.settings:{}) as Record<string,unknown>;
    const deliverable=String(settings.marketingDeliverableId||parsed.marketingDeliverableId||'');
    if(!deliverable||grant.deliverableIds.length&&!grant.deliverableIds.includes(deliverable))return null;
    return grant;
  }
  if(grant)return null;
  const film=filmGrants.get(projectId);
  return film?{id:film,deliverableIds:[]}:null;
}
export function bodyWithGrant(body:string,grantId:string) {
  return JSON.stringify({...JSON.parse(body||'{}'),productionGrant:grantId});
}
